import { lazy } from 'react';

export { default as Loading } from './Loading/Loading';

const LazyPages = {
    Home: lazy(() => import('./Home/Home')),
    AboutUs: lazy(() => import('./AboutUs/AboutUs')),
    ContactUs: lazy(() => import('./ContactUs/ContactUs')),
    Advantage: lazy(() => import('./Advantage/Advantage')),
    PrivacyPolicy: lazy(() => import('./PrivacyPolicy/PrivacyPolicy')),
    AmlPolicy: lazy(() => import('./AmlPolicy/AmlPolicy')),
    AntiFraudPolicy: lazy(() => import('./AntiFraudPolicy/AntiFraudPolicy'))
};

export default LazyPages;
